/* Added by MORYARTY (MOD-131) — wishlist hearts on product cards that arrive after page load.

   The wishlist app embed (my-wishlist — our own app, repo my-shopify-wishlist) adds its heart
   buttons ONCE, when its list has loaded (wishlist.js init → decorate()). It has no observer,
   so cards the theme inserts later never got a heart:
     - collection "Load more" (MOD-041 appends <li>s into #product-grid)
     - filter / sort on collection + search pages (Dawn facets.js replaces #ProductGridContainer)
     - Dawn's product recommendations (<product-recommendations>, fetched on scroll)
   The app exposes window.MoryartyWishlist.decorate(root), which skips cards that already carry
   a heart — so we watch the page and call it on each container that just gained product cards.

   Only nodes that are or contain a Dawn card wrapper count; the hearts the app inserts are
   plain buttons, so decorating can't re-trigger the observer. No-op while the app isn't on the
   page (embed off, e.g. unpublished themes) — its own init still decorates the whole page.

   Gated on the app's first successful list load: decorate() paints each heart from the app's
   saved-list state, which is empty until /apps/my-wishlist/list answers. If that request fails
   the app shows no hearts at all, so we add none either (instead of "not saved" hearts that
   alert on click). Cards inserted before the load are covered by the app's own init decorate().
*/
(function () {
  'use strict';

  if (!('MutationObserver' in window) || !document.body) return;

  var CARD = '.card-wrapper, .product-card-wrapper';
  var hooked = null; // the app API we subscribed to
  var ready = false; // the app's list has loaded at least once

  /* Subscribe to the app's list changes (once per API object) and work out whether its first
     load has already happened. api = window.MoryartyWishlist. */
  function hook(api) {
    if (hooked === api) return;
    hooked = api;
    if (typeof api.onChange !== 'function') {
      ready = true; // an app version without onChange: no signal to wait for
      return;
    }
    // onChange fires on every list change, the first one being the initial load.
    api.onChange(function () { ready = true; });
    // The load may have finished before we subscribed (this script runs before wishlist.js,
    // but the list request can return while later deferred scripts still download): the
    // app's first decorate() has then already put hearts on the page.
    if (document.querySelector('.wishlist-heart')) ready = true;
  }

  /* wishlist.js is a deferred script AFTER this one in <head>, so its API exists only by
     DOMContentLoaded. The observer below also hooks lazily, in case the app arrives later. */
  function hookWhenLoaded() {
    var api = window.MoryartyWishlist;
    if (api && typeof api.decorate === 'function') hook(api);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hookWhenLoaded);
  } else {
    hookWhenLoaded();
  }

  new MutationObserver(function (records) {
    var api = window.MoryartyWishlist;
    if (!api || typeof api.decorate !== 'function') return;
    hook(api);
    if (!ready) return;

    var roots = [];
    for (var i = 0; i < records.length; i++) {
      var added = records[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var node = added[j];
        if (node.nodeType === 1 && (node.matches(CARD) || node.querySelector(CARD))) {
          if (roots.indexOf(records[i].target) === -1) roots.push(records[i].target);
          break;
        }
      }
    }

    for (var k = 0; k < roots.length; k++) {
      if (!roots[k].isConnected) continue;
      try {
        api.decorate(roots[k]);
      } catch (e) {
        /* the app's own init still covers the initial page */
      }
    }
  }).observe(document.body, { childList: true, subtree: true });
})();
